import Vue from 'vue';
import axios from 'axios';
import VeeValidate, { Validator } from 'vee-validate';

import buttonLoader from '../../../components/button';

Vue.use(VeeValidate);
export default Vue.extend({
  components: {
    buttonLoader,
  },
  data () {
    return {
      data: {
        Request: {
          password: '',
          oldPassword: '',
        },
      },
      response: {},
      oldPassword: '',
      password: '',
      confirmedPassword: '',
      hidePassword: true,
      hidePasswordNew: true,
      hidePasswordConf: true,
      message: '',
      active: false,
      mediumRegex: new RegExp('^[a-zA-Z0-9!@#$%^&*+-]{6,21}$'),
      loading: false,
    };
  },
  methods: {
    setPassword () {
      this.loading = true;
      this.$validator.validateAll().then((result) => {
        if (result == true) {
          this.data.Request.oldPassword = this.oldPassword;
          this.data.Request.password = this.password;

          axios.post(`${this.$store.getters.rootAPI}/user/changePassword`, this.data).then((response) => {
            this.message = response.data.message;
            this.loading = false;
            setTimeout(() => { this.$router.push('/account_settings'); }, 2000);
          });
        } else {
          this.loading = false;
        }
      });
    },
    mouseOver: () => {
      this.active = !this.active;
    },
  },
  computed: {
    passwordType () {
      return this.hidePassword ? 'password' : 'text';
    },
    passwordTypeConf () {
      return this.hidePasswordNew ? 'password' : 'text';
    },
    passwordTypeNew () {
      return this.hidePasswordConf ? 'password' : 'text';
    },
    passwordIcon () {
      return this.hidePassword ? 'fa-eye' : 'fa-eye-slash';
    },
  },
  mounted () {
    const isOld = (value) => {
      return axios.post(`${this.$store.getters.rootAPI}/user/checkUserPassword`, {
        Request: {
          password: value,
        },
      }).then((response) => {
        return response.status === 200 && response.data.status
          ? { valid: true } : {
            valid: false,
            data: {
              message: 'Incorrect password.',
            },
          };
      });
    };

    Validator.extend('old', {
      validate: isOld,
      getMessage: (field, params, data) => data.message,
    });
  },
});
